import { ReferenceInput, SelectInput, SelectInputProps } from "react-admin";

interface CitySelectInputProps
  extends Omit<SelectInputProps, "source" | "choices"> {
  source: string;
  label?: string;
}

const CitySelectInput = (props: CitySelectInputProps) => {
  const { source, label = "City", ...rest } = props;

  return (
    <ReferenceInput source={source} reference="cities" label={label}>
      <SelectInput optionText="name" resettable fullWidth {...rest} />
    </ReferenceInput>
  );
};

export default CitySelectInput;
